import { LinearProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FormattedMessage } from 'react-intl';
import { DownloadStatus } from '@/contexts/DownloadContext';

export const DownloadManagerStatus = ({
  status,
  progress,
  preparing,
  failedCount,
  onShowFailedFiles,
}: {
  status: DownloadStatus;
  progress?: number;
  preparing?: boolean;
  failedCount: number | null;
  onShowFailedFiles?: () => void;
}) => {
  switch (status) {
    case 'pending':
      if (preparing) {
        return (
          <>
            <FormattedMessage
              id="preparingDownload"
              defaultMessage="Preparing download…"
            />
            <ProgressWrapper>
              <LinearProgress variant="indeterminate" />
            </ProgressWrapper>
          </>
        );
      }
      return (
        <ProgressWrapper>
          <LinearProgress
            variant={
              typeof progress === 'number'
                ? 'determinate'
                : 'indeterminate'
            }
            {...(typeof progress === 'number'
              ? { value: progress }
              : {})}
          />
        </ProgressWrapper>
      );
    case 'completed':
      return (
        <FormattedMessage
          id="downloadStarted"
          defaultMessage="Download started"
        />
      );
    case 'failed':
      // `failedCount` is null when the request itself failed before
      // any signed urls came back - there's no per-file count to show.
      return failedCount == null ? (
        <FormattedMessage
          id="failedToDownload"
          defaultMessage="Failed to download"
        />
      ) : onShowFailedFiles ? (
        <FailedCountButton
          type="button"
          onClick={onShowFailedFiles}
        >
          <FormattedMessage
            id="failedToDownloadNoOfFiles"
            defaultMessage="{failedCount, plural, one {# file} other {# files}} failed to download"
            values={{ failedCount }}
          />
        </FailedCountButton>
      ) : (
        <FormattedMessage
          id="failedToDownloadNoOfFiles"
          defaultMessage="{failedCount, plural, one {# file} other {# files}} failed to download"
          values={{ failedCount }}
        />
      );
  }
};

const FailedCountButton = styled('button')(({ theme }) => ({
  all: 'unset',
  cursor: 'pointer',
  textDecoration: 'underline',
  color: theme.palette.white,
  font: 'inherit',
}));

const ProgressWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  height: 20,

  '> span': {
    width: '100%',
  },
});
